import script from "./LoginAccessView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginAccessView.vue?vue&type=script&setup=true&lang=ts"

import "./LoginAccessView.vue?vue&type=style&index=0&id=c565c9ca&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c565c9ca"]])

export default __exports__